module.exports = __webpack_public_path__ + "static/media/point_logo.eb9ca091.png";